import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function HemlockPage() {
  const location = getLocationById('hemlock');
  if (!location) {
    return <div data-id="element-796">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-797">
      <Header data-id="element-798" />

      <main className="pt-20" data-id="element-799">
        <LocationPageHero location={location} data-id="element-800" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-801" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-802" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-803" />
      </main>

      <Footer data-id="element-804" />
    </div>;
}